import React, { useState } from 'react';
import {
    Modal, Box, Typography, Button, IconButton,ToggleButton, ToggleButtonGroup
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import GeometryEditorMap from './GeometryEditorMap';

const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '90%',
    maxWidth: 1200,
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    borderRadius: 2,
};

const GeometryEditorModal = ({ open, onClose, onSave, expectedGeometryType }) => {
    const [geometry, setGeometry] = useState(null);
    const [basemap, setBasemap] = useState('satellite');

    const handleSave = () => {
        onSave(geometry);
        onClose();
    };

    const handleBasemapChange = (event, newBasemap) => {
        if (newBasemap !== null) {
            setBasemap(newBasemap);
        }
    };

    return (
        <Modal
            open={open}
            onClose={onClose}
            aria-labelledby="geometry-editor-modal-title"
            aria-describedby="geometry-editor-modal-description"
        >
            <Box sx={modalStyle}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                    <Typography id="geometry-editor-modal-title" variant="h6" component="h2">
                        Draw Asset Geometry
                    </Typography>
                    <IconButton onClick={onClose}>
                        <CloseIcon />
                    </IconButton>
                </Box>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                    <Typography id="geometry-editor-modal-description">
                        Use the tools on the map to draw the asset's geometry. Expected type: {expectedGeometryType}
                    </Typography>
                    <ToggleButtonGroup
                        value={basemap}
                        exclusive
                        onChange={handleBasemapChange}
                        aria-label="basemap selection"
                    >
                        <ToggleButton value="satellite" aria-label="satellite view">
                            Satellite
                        </ToggleButton>
                        <ToggleButton value="street" aria-label="street view">
                            Street
                        </ToggleButton>
                    </ToggleButtonGroup>
                </Box>
                <GeometryEditorMap onGeometryChange={setGeometry} expectedGeometryType={expectedGeometryType} basemap={basemap} />
                <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
                    <Button onClick={onClose}>Cancel</Button>
                    <Button variant="contained" onClick={handleSave} disabled={!geometry}>
                        Save Geometry
                    </Button>
                </Box>
            </Box>
        </Modal>
    );
};

export default GeometryEditorModal;